import { SupportedPayInMethodType } from '../entity'

export const offlineType = [SupportedPayInMethodType.OFFLINE]
export const isPaidOffline = (payInMethodType: SupportedPayInMethodType) => offlineType.includes(payInMethodType)
